import { CustomArray } from "../../../common/CustomArray";
import {StationDataItemInfo }from "./StationDataItemInfo";


export class  StationDataItemInfos extends CustomArray  {

	constructor()
	{
		super();
		
	}

	 static  GetStationDataItems(jsonItems)
		{	
			let dataItems=null;
			if(jsonItems==null)return dataItems;
			dataItems=new StationDataItemInfos();
			
			let tempDataItem=null;
			for (let tempIndex in jsonItems) 
			{	
				tempDataItem = StationDataItemInfo.GetStationDataItem(jsonItems[tempIndex]);
				dataItems.push(tempDataItem);
			}
			
			return dataItems;
		}	

}//end StationDataItemInfos

